import { ArrowRight, MessageSquare, Database } from 'lucide-react';
import { Button, buttonVariants } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { cn } from "@/lib/utils";

const CTA = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background gradient and elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background to-primary/5 -z-10" />
      <div className="absolute -right-32 -top-32 h-[30rem] w-[30rem] bg-primary/10 rounded-full blur-3xl opacity-70 -z-10"></div>
      <div className="absolute -left-32 -bottom-32 h-[30rem] w-[30rem] bg-primary/10 rounded-full blur-3xl opacity-70 -z-10"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 relative">
        <div className="text-center mb-12">
          <motion.div
            className="inline-flex items-center px-4 py-2 rounded-full bg-primary/10 text-primary mb-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Database className="h-4 w-4 mr-2" />
            <span>Introducing Metanet Technologies</span>
          </motion.div>

          <motion.h2
            className="text-4xl md:text-5xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-primary to-blue-500"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            Metanet in a Box
          </motion.h2>
          <motion.p
            className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            Everything that is needed to create powerful applications on the Metanet is available — today!
          </motion.p>

          <motion.div
            className="flex flex-col sm:flex-row gap-4 justify-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <Link 
              to="/contact" 
              className={cn(
                buttonVariants({ size: 'lg' }), 
                "group bg-gradient-to-r from-primary to-blue-500 hover:from-primary/90 hover:to-blue-500/90"
              )}
            >
              Schedule a Consultation
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
            <Button
              variant="outline"
              size="lg"
              onClick={() => window.open('https://docs.projectbabbage.com/', '_blank')}
            >
              Read Documentation
              <MessageSquare className="ml-2 h-4 w-4" />
            </Button>
          </motion.div>
        </div>

        {/* Social proof section */}
        {/* <motion.div
          className="mt-16 pt-8 border-t border-border"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <p className="text-center text-sm text-muted-foreground mb-6">
            TRUSTED BY LEADING COMPANIES WORLDWIDE
          </p>
          <div className="flex justify-center flex-wrap gap-8 opacity-70">
            {['Company 1', 'Company 2', 'Company 3', 'Company 4', 'Company 5'].map((company, idx) => (
              <div key={idx} className="h-8 w-24 bg-muted rounded animate-pulse"></div>
            ))}
          </div>
        </motion.div> */}
      </div>
    </section>
  );
};

export default CTA;
